import { useMutation, useQueryClient } from "@tanstack/react-query";

import { requests } from "api";

import { COMPANY_VEHICLES_QUERY_KEY } from "./useCompanyVehiclesQuery";

export const useEditVehicleMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requests.legalCabinetGatewayEditVehicle.bind(requests),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: COMPANY_VEHICLES_QUERY_KEY })
  });
};
